// src/lib/supabase.js
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://nibmpazvfqeuobgwyvtr.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5pYm1wYXp2ZnFldW9iZ3d5dnRyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc5NTE0OTEsImV4cCI6MjA5MzUyNzQ5MX0.3r6azsa_XkhyeoAnm7HT_78npi0JQmwIqFNjstVIZ_I';

// persistSession: false means session clears when browser is closed
// User must sign in again each time they open the site in a new browser session
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: false,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
});
